export const hasAccess = (
    userRoles: string[],
    role: string | string[]
): boolean => {
    let canAccess = false

    if (typeof role === 'string') {
        canAccess = userRoles.includes(role)
    } else if (Array.isArray(role)) {
        for (const i in role) {
            if (userRoles.includes(role[i])) {
                canAccess = true
                break
            }
        }
    }

    return canAccess
}
